<template>
  <v-container
    fluid
    class="login-shell pa-0 ma-0"
  >
      <div class="login-ambient"></div>
      <v-row
        align="center"
        justify="center"
        class="fill-height ma-0"
      >
    <v-col
      cols="12"
      sm="9"
      md="6"
      lg="4"
      class="px-4"
    >
        <v-card
          class="mx-auto login-card elevation-12"
        >
      <v-toolbar
        class="mb-3 login-toolbar"
        dark
        flat
        color="primary"
      >
          <v-toolbar-title class="font-weight-bold">
        {{ $t('mensaje_login')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
      </v-toolbar>
      <v-img
        class="mx-6 mt-2"
        :src="language === 'es' ? require('../assets/residencial_mx.png') : require('../assets/residencial_eu.png')"
        height="200px"
        contain
      ></v-img>
      <v-card-text class="pt-2 pb-6 px-6 px-sm-8">
<!--                            <ValidationObserver v-slot="{ handleSubmit }">-->
                                <v-form
          class="mb-2"
                                        @submit.prevent="login()"
                                >
                                    <v-text-field
                                            autofocus
                                            v-model="correo"
                                            name="correo"
                                            prepend-icon="mdi-account"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                            v-model="password"
                                            name="password"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                          :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
                                          @click:append="show = !show"
                                            :error-messages="errores.password">
                                    </v-text-field>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.non_field_errors}}
                                    </v-alert>

                                    <v-card-actions>
                                        <v-flex>
                                            <span>{{$t('mensaje_olvidar_contrasena')}}</span>
                                            <span>
                                                {{$t('mensaje_link_restablecer1')}}
                                                <router-link :to="{ name: 'reset_password'}">
                                                    {{$t('mensaje_link_restablecer2')}}
                                                </router-link>
                                                {{$t('mensaje_link_restablecer3')}}
                                            </span>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                    <v-btn
                                            :loading="loading"
                                            color="primary"
                                            type="submit"
                                        block
                                        class="mt-2"
                                    >
                                        {{$t('ingresar')}}
                                    </v-btn>

                                    <v-btn
                                            to="/signup_apartment"
                                            block
                                            color="primary"
                                        outlined
                                        class="mt-4"
                                    >{{$t('sign_up_house')}}
                                        <v-icon right dark>mdi-home-edit</v-icon>
                                    </v-btn>
                                </v-form>
<!--                            </ValidationObserver>-->
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { AUTH_REQUEST } from '../store/actions/auth'
import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)

export default {
  name: 'Login',
  data: () => ({
    errores: [],
    show: false,
    correo: '',
    password: '',
    alerta: false,
    loading: false
  }),
  computed: {
    ...mapState(['language'])
  },
  methods: {
    login () {
      this.loading = true
      this.$store.dispatch(AUTH_REQUEST, { email: this.correo, password: this.password, language: this.language })
        .then(ok => {
          this.loading = false
          if (localStorage.getItem('pathValidationUser') !== null) {
            this.$router.push({ path: localStorage.getItem('pathValidationUser') })
            localStorage.removeItem('pathValidationUser')
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(error => {
          // if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          // console.log(error)
          this.errores = error.response.data
          this.loading = false
          if (error.response.data['non_field_errors'] != null) {
            this.alerta = true
            setTimeout(this.clear, 2000)
            this.loading = false
          }
          // }
        })
    },
    clear () {
      this.alerta = false
      this.errores = []
      // this.$validator.reset()
    }
  }
}
</script>

<style scoped>
.login-shell {
  position: relative;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: linear-gradient(135deg, #e7edf3 0%, #d8e4f0 100%);
}

.login-ambient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(circle at 20% 20%, rgba(15, 42, 68, 0.16), transparent 38%),
    radial-gradient(circle at 80% 85%, rgba(0, 121, 107, 0.15), transparent 42%);
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  border-radius: 18px;
}

.login-toolbar {
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

@media (max-width: 600px) {
  .login-card {
    max-width: 100%;
    border-radius: 14px;
  }

  .login-toolbar {
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
  }
}
</style>
